import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import SectionHeader from '../../components/SectionHeader'
import NoImage from "../../images/NoImage.jpg"
import HeaderImage from '../../images/section-herder-img.jpg'
import { Card, Container } from 'react-bootstrap';
import { FaUser } from "react-icons/fa6";
import { IoCalendarOutline } from "react-icons/io5";
import { Link } from 'react-router-dom';
import axios from 'axios';

const Blogs = () => {
    const [blog, setBlog] = useState([]);
    const baseURL = "https://backend.fronteda.devhub.digtalsdesigns.com/public/";
    useEffect(() => {
        axios.get('https://backend.fronteda.devhub.digtalsdesigns.com/api/blog-show')
            .then(response => {
                setBlog(response.data);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });
    }, []);
    useEffect(() => {
        AOS.init();
    }, []);
    return (
        <>
            <SectionHeader title='Blogs' image={HeaderImage} PageLink='Blogs'></SectionHeader>
            <section className="blog-bg">
                <Container className='blog-post'>
                    <div className="blog-posts" data-aos="zoom-in-up" data-aos-duration="2000" data-aos-easing="linear">
                        {
                            blog.map(({ id, image, date, description }) => {
                                return (
                                    <Card className='blog_card' key={id}>
                                        {image ? (
                                            <Card.Img className="blog_card_img" variant="top"
                                                src={`${baseURL}${image}`}
                                            />
                                        ) : (
                                            <Card.Img className="blog_card_img" variant="top" src={NoImage} alt="Product img" />
                                        )}
                                        <Card.Body className='blog_text'>
                                            <div className="date_admin">
                                                <Link to="#">
                                                    <p><span><IoCalendarOutline /></span>{date}</p>
                                                </Link>
                                                <Link to="#">
                                                    <p><span><FaUser /></span> Admin</p>
                                                </Link>
                                            </div>
                                            <p className="bolg_text">
                                                <div dangerouslySetInnerHTML={{ __html: description }} />
                                            </p>
                                        </Card.Body>
                                    </Card>
                                )
                            })
                        }
                    </div>
                </Container>
            </section>
        </>
    )
}

export default Blogs